import React, { useState } from 'react'
import ModalInfo from '../productinfo/ModalInfo'
import isAuthorized from '../../utils/constants/isAuthorized'

const Brand = ({ articleBrandParts }) => {
    const [isModalActive, setIsModalActive] = useState(false)

    const handleClick = () => {
        if (isAuthorized) {

            setIsModalActive(true)
        }
    }

    return (
        <>
            <ModalInfo
                articleBrandParts={articleBrandParts}
                title={articleBrandParts.title}
                brand={articleBrandParts.brand_title}
                article={articleBrandParts.original_article}
                isModalActive={isModalActive}
                setIsModalActive={setIsModalActive}
                activeTab={2}
            />
            <span className="result-table__info-brand" onClick={handleClick}>
                
                <span>{articleBrandParts.brand_title}</span>
            </span>
        </>
    )
}

export default Brand
